"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepClient = void 0;
const axios_interceptors_1 = require("@deliverr/axios-interceptors");
const core_client_1 = require("@deliverr/core-client");
const openapi_1 = require("./generated-sources/openapi");
const service_api_1 = require("./generated-sources/openapi/api/service-api");
class PrepClient extends core_client_1.OpenApiGeneratedClient {
    constructor(config) {
        super(config);
        this.PDF_DOWNLOAD_REQUEST_OPTIONS = {
            responseType: "text",
            responseEncoding: "base64",
        };
    }
    addAxiosInterceptors() {
        super.addAxiosInterceptors();
        this.axios.interceptors.request.use((0, axios_interceptors_1.buildOutgoingDirectCallerRequestInterceptor)());
        return this;
    }
    getDefaultServiceUrlEnvKey() {
        return PrepClient.SERVICE_URL_ENV_KEY;
    }
    instantiateOpenApiGeneratedApi() {
        return new service_api_1.ServiceApi(new openapi_1.Configuration(this.getConfigurationParameters()), undefined, this.axios);
    }
    async addPrepTypesToPrepJob(prepJobRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().addPrepTypesToJob(prepJobRequest);
            return prepJob.data;
        });
    }
    async removePrepTypesFromJob(dpId, prepTypesToRemove) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().removePrepTypesFromJob(dpId, prepTypesToRemove);
            return prepJob.data;
        });
    }
    async initializeJob(dpId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().initializePrepJob(dpId, request);
            return prepJob.data;
        });
    }
    async receiveJob(dpId, location) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().receivePrepJob(dpId, { location });
            return prepJob.data;
        });
    }
    async startJob(dpId, location) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().startPrepJob(dpId, { location });
            return prepJob.data;
        });
    }
    async completeJob(dpId, location) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().completePrepJob(dpId, { location });
            return prepJob.data;
        });
    }
    async undoPrepJobCompletion(dpId, isSoftUndo) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().undoPrepJobCompletion(dpId, isSoftUndo);
            return prepJob.data;
        });
    }
    async undoPrepTypeCompletion(dpId, prepTypes, isSoftUndo, withDetails) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().undoPrepTypeCompletion(dpId, prepTypes, isSoftUndo, withDetails);
            return prepJob.data;
        });
    }
    async approvalForPrepType(dpId, prepTypes) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().approvalForPrepType(dpId, prepTypes);
            return prepJob.data;
        });
    }
    async moveJob(dpId, location) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().movePrepJob(dpId, { location });
            return prepJob.data;
        });
    }
    async completePrepTask(dpId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().completePrepTask(dpId, request);
            return prepJob.data;
        });
    }
    async completeBoxBuild(dpId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().completeBoxBuild(dpId, request);
            return prepJob.data;
        });
    }
    async validateLocationForPrepJob(dpId, action, location) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().validateLocationForPrepJob(dpId, action, location);
            return prepJob.data;
        });
    }
    async getJobByDpIdV2(dpId, withDetails) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJob = await this.getOpenApiGeneratedApi().getPrepJobByDpId(dpId, withDetails);
            return prepJob.data;
        });
    }
    async getJobsByDpIds(dpIds, withDetails) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJobs = await this.getOpenApiGeneratedApi().getPrepJobsByDpIds(dpIds, withDetails);
            return prepJobs.data;
        });
    }
    async getJobsForFacility(facilityId, stage, hideAdminTestSellers) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJobs = await this.getOpenApiGeneratedApi().getPrepJobsForFacility(facilityId, stage, hideAdminTestSellers);
            return prepJobs.data;
        });
    }
    async getPrepJobMetadata(dpId) {
        return await this.wrapClientOperationExecution(async () => {
            const url = await this.getOpenApiGeneratedApi().getPrepJobMetadata(dpId);
            return url.data;
        });
    }
    async scanBarcodeForBoxConfiguration(dpId, boxConfigUuid, scanRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const scanResponse = await this.getOpenApiGeneratedApi().scanBarcode(dpId, boxConfigUuid, scanRequest);
            return scanResponse.data;
        });
    }
    async initializeBoxConfiguration(dpId) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().initializeBoxConfiguration(dpId);
            return backendResponse.data;
        });
    }
    async updateBoxConfigurationItem(dpId, boxConfigurationUuid, dsku, request) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().updateBoxConfigurationItem(dpId, boxConfigurationUuid, dsku, request);
            return response.data;
        });
    }
    async getBoxConfigurations(dpId, includePackages) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getBoxConfigurations(dpId, includePackages);
            return response.data;
        });
    }
    async finalizeBoxConfiguration(dpId, boxConfigUuid, finalizationRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().finalizeBoxConfiguration(dpId, boxConfigUuid, finalizationRequest);
            return backendResponse.data;
        });
    }
    async scanActivePackage(boxConfigUuid, cdsku) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().scanActivePackage(boxConfigUuid, cdsku);
            return backendResponse.data;
        });
    }
    async deactivatePackage(boxConfigUuid, sellerId, shippingPlanId, cdsku) {
        return await this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().deactivatePackage(boxConfigUuid, sellerId, shippingPlanId, cdsku);
        });
    }
    async downloadBoxContentLabelsForBoxConfiguration(dpId, boxConfigurationUuid, labelFormat) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().downloadBoxContentLabels(dpId, boxConfigurationUuid, labelFormat, labelFormat === openapi_1.BoxContentLabelFormat.PDF ? this.PDF_DOWNLOAD_REQUEST_OPTIONS : undefined);
            return backendResponse.data;
        });
    }
    async translateBarcode(dpId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().translateBarcode(dpId, request);
            return backendResponse.data;
        });
    }
    async getPrintJobsByDpId(dpId) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().getUnitLabelPrintJobsByDpId(dpId);
            return backendResponse.data;
        });
    }
    async generateZPLUnitLabels(dpId, printJobUuid, printOptions) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().generateZPLUnitLabels(dpId, printJobUuid, printOptions.labelFormat, printOptions.quantity);
            return backendResponse.data;
        });
    }
    async generatePDFUnitLabels(dpId, printJobUuid, printOptions) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().generatePDFUnitLabels(dpId, printJobUuid, printOptions.labelFormat, printOptions.quantity, this.PDF_DOWNLOAD_REQUEST_OPTIONS);
            return backendResponse.data;
        });
    }
    async addCustomUnitLabelSubtasksForJob(dpId, subtasks) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().addCustomUnitLabelSubtasksForJob(dpId, subtasks);
            return backendResponse.data;
        });
    }
    async getCustomUnitLabelSubtasksForJob(dpId) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().getCustomUnitLabelSubtasksForJob(dpId);
            return backendResponse.data;
        });
    }
    async generateZPLBarcodeTranslation(dpId, barcodeTranslationUuid, qty) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().generateZPLBarcodeTranslation(dpId, barcodeTranslationUuid, { qty });
            return backendResponse.data;
        });
    }
    async generatePDFBarcodeTranslation(dpId, barcodeTranslationUuid, qty) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().generatePDFBarcodeTranslation(dpId, barcodeTranslationUuid, { qty }, this.PDF_DOWNLOAD_REQUEST_OPTIONS);
            return backendResponse.data;
        });
    }
    async updateSimplePrepForJob(sellerId, sourceType, sourceId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJobResponse = await this.getOpenApiGeneratedApi().updateSimplePrepForJob(sellerId, sourceType, sourceId, request);
            return prepJobResponse.data;
        });
    }
    async updateShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJobResponse = await this.getOpenApiGeneratedApi().updateShippingPlanSelfServePrepForJob(sellerId, shippingPlanId, request);
            return prepJobResponse.data;
        });
    }
    async updateShippingPlanSelfServePrepRequestsForJob(sellerId, shippingPlanId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJobResponse = await this.getOpenApiGeneratedApi().updateShippingPlanSelfServePrepRequestsForJob(sellerId, shippingPlanId, request);
            return prepJobResponse.data;
        });
    }
    async getShippingPlanSelfServePrepForJob(sellerId, shippingPlanId) {
        return this.wrapClientOperationExecution(async () => {
            const selfServeResponse = await this.getOpenApiGeneratedApi().getShippingPlanSelfServePrepForJob(sellerId, shippingPlanId);
            return selfServeResponse.data;
        });
    }
    async updateWholesaleSelfServePrepForJob(sellerId, wholesaleShipmentId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJobResponse = await this.getOpenApiGeneratedApi().updateWholesaleShipmentSelfServePrepForJob(sellerId, wholesaleShipmentId, request);
            return prepJobResponse.data;
        });
    }
    async getPrepJobBySellerAndSource(sellerId, sourceType, sourceId, withDetails) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJobResponse = await this.getOpenApiGeneratedApi().getPrepJobBySellerAndSource(sellerId, sourceType, sourceId, withDetails);
            return prepJobResponse.data;
        });
    }
    async updatePrepJobDestination(dpId, updateDestinationRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJobResponse = await this.getOpenApiGeneratedApi().updatePrepJobDestination(dpId, updateDestinationRequest);
            return prepJobResponse.data;
        });
    }
    async reportJobNonCompliance(dpId) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJobResponse = await this.getOpenApiGeneratedApi().reportPrepJobNonCompliance(dpId);
            return prepJobResponse.data;
        });
    }
    async resolveJobNonCompliance(dpId) {
        return await this.wrapClientOperationExecution(async () => {
            const prepJobResponse = await this.getOpenApiGeneratedApi().resolvePrepJobNonCompliance(dpId);
            return prepJobResponse.data;
        });
    }
    async archiveJob(dpId) {
        return await this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().archivePrepJob(dpId);
        });
    }
    async createFacilityJobLocation(facilityId, location, jobLocationType) {
        return this.wrapClientOperationExecution(async () => {
            const facilityJobLocationResponse = await this.getOpenApiGeneratedApi().createFacilityJobLocation(facilityId, {
                location,
                jobLocationType,
            });
            return facilityJobLocationResponse.data;
        });
    }
    async archiveFacilityJobLocation(facilityId, location) {
        return this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().archiveFacilityJobLocation(facilityId, location);
        });
    }
    async uploadCartonLabel(dpId, type, url, name) {
        return this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().uploadCartonLabel(dpId, { type, url, name });
        });
    }
    async redirectCartonLabelDownloadToPresignedS3Url(dpId, type, name) {
        return this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().redirectCartonLabelDownloadToPresignedS3Url(dpId, type, name);
        });
    }
    async getCartonLabelDownloadUrl(dpId, type, name) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getCartonLabelDownloadUrl(dpId, type, name);
            return response.data;
        });
    }
    async updatePrepTaskSubtype(dpId, updatePrepSubtypeRequest, shouldUpdateUnitLabelPrintJobs) {
        return this.wrapClientOperationExecution(async () => {
            const prepJobResponse = await this.getOpenApiGeneratedApi().updatePrepTaskSubtype(dpId, updatePrepSubtypeRequest, shouldUpdateUnitLabelPrintJobs);
            return prepJobResponse.data;
        });
    }
    async updatePrepJobNote(dpId, updatePrepNoteRequest) {
        return this.wrapClientOperationExecution(async () => {
            const prepJobResponse = await this.getOpenApiGeneratedApi().updatePrepJobNote(dpId, updatePrepNoteRequest);
            return prepJobResponse.data;
        });
    }
    async getPrepReserveStorageLabelForWholesaleShipment(wholesaleShipmentId) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().getPrepReserveStorageLabelForWholesaleShipment(wholesaleShipmentId, this.PDF_DOWNLOAD_REQUEST_OPTIONS);
            return backendResponse.data;
        });
    }
    async setPalletLabelQuantity(dpId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const backendResponse = await this.getOpenApiGeneratedApi().setPalletQuantity(dpId, request);
            return backendResponse.data;
        });
    }
    async uploadPalletLabel(dpId, request) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().uploadPalletLabel(dpId, request);
            return response.data;
        });
    }
    async getPalletLabelDownloadUrl(dpId) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getPalletLabelDownloadUrl(dpId);
            return response.data;
        });
    }
    async addFloorLoadedContainerForSourceTypeAndId(sourceType, sourceId, request) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().addFloorLoadedContainerForSourceTypeAndId(sourceType, sourceId, request);
            return response.data;
        });
    }
    async updateLotFefoDataForUnitLabel(dpId, uuid, request) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().updateLotFefoDataForUnitLabel(dpId, uuid, request);
            return response.data;
        });
    }
    async removeKitFromJob(dpId, kittingUuid) {
        return await this.wrapClientOperationExecution(async () => {
            await this.getOpenApiGeneratedApi().removeKitFromJob(dpId, kittingUuid);
        });
    }
    async addKitsToJob(dpId, request) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().addKitsToJob(dpId, request);
            return response.data;
        });
    }
    async addKitsByShippingPlan(sellerId, shippingPlanId) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().addKitsByShippingPlan(sellerId, shippingPlanId);
            return response.data;
        });
    }
    async completeKitFromJob(dpId, kittingUuid, request) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().completeKitFromJob(dpId, kittingUuid, request);
            return response.data;
        });
    }
    async getKittingInstructions(dpId, dsku) {
        return this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getKittingInstructions(dpId, dsku);
            return response.data;
        });
    }
    async fetchEstimates(request) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().fetchEstimates(request);
            return response.data;
        });
    }
    async prepareKitLotInfoFromComponentLotInfo(dpId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().prepareKitLotInfoFromComponentLotInfo(dpId, request);
            return response.data;
        });
    }
    async scanSource(xUserId, xDeviceId, xWarehouseId, body, options) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().scanSource(xUserId, xDeviceId, xWarehouseId, body, options);
            return response.data;
        });
    }
    async genericScanSource(xUserId, xDeviceId, xWarehouseId, body, options) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().scanSourceV2(xUserId, xDeviceId, xWarehouseId, body, options);
            return response.data;
        });
    }
    async scanUnitOfWork(xUserId, body, options) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().scanUnitOfWork(xUserId, body, options);
            return response.data;
        });
    }
    async getSignedDownloadUrl(s3KeyRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getSignedDownloadUrl(s3KeyRequest);
            return response.data;
        });
    }
    async getSignedUploadUrl(s3KeyRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getSignedUploadUrl(s3KeyRequest);
            return response.data;
        });
    }
    async patchWorkflow(xUserId, taskId, workflowTaskPatchRequest, options) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().patchWorkflow(xUserId, taskId, workflowTaskPatchRequest, options);
            return response.data;
        });
    }
    async patchUnitOfWork(xUserId, patchUnitOfWorkRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().patchUnitOfWork(xUserId, patchUnitOfWorkRequest);
            return response.data;
        });
    }
    async genericPatchWork(xUserId, patchUnitOfWorkRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().patchUnitOfWorkV2(xUserId, patchUnitOfWorkRequest);
            return response.data;
        });
    }
    async getTaskDetails(taskId) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getTaskDetails(taskId);
            return response.data;
        });
    }
    async genericGetTaskDetails(taskId) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getTaskDetailsV2(taskId);
            return response.data;
        });
    }
    async onSourceIdScan(xUserId, xDeviceId, xWarehouseId, sourceScanRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().onSourceIdScan(xUserId, xDeviceId, xWarehouseId, sourceScanRequest);
            return response.data;
        });
    }
    async initiateWorkflowSession(xUserId, xDeviceId, workflowSessionRequest, options) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().initiateWorkflowSession(xUserId, xDeviceId, workflowSessionRequest, options);
            return response.data;
        });
    }
    async getWorkflowTaskDetails(sourceId, taskId, options) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getWorkflowTaskDetails(sourceId, taskId, options);
            return response.data;
        });
    }
    async createUnitOfWorkV2(xUserId, unitOfWorkScanRequest, options) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().createUnitOfWorkV2(xUserId, unitOfWorkScanRequest, options);
            return response.data;
        });
    }
    async completeTask(xUserId, workflowTaskCompleteRequest, options) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().completeTask(xUserId, workflowTaskCompleteRequest, options);
            return response.data;
        });
    }
    async updatePrepJobSource(dpId, request) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().updatePrepJobSource(dpId, request);
            return response.data;
        });
    }
    async genericPatchWorkV2(xUserId, patchUnitOfWorkRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().updateUnitOfWork(xUserId, patchUnitOfWorkRequest);
            return response.data;
        });
    }
    async getTaskInstructions(taskId, searchTaskInstructionRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().getTaskInstructions(taskId, searchTaskInstructionRequest);
            return response.data;
        });
    }
    async resetWorkflow(xUserId, resetWorkflowRequest) {
        return await this.wrapClientOperationExecution(async () => {
            const response = await this.getOpenApiGeneratedApi().resetWorkflow(xUserId, resetWorkflowRequest);
            return response.data;
        });
    }
}
exports.PrepClient = PrepClient;
PrepClient.SERVICE_URL_ENV_KEY = "PREP_SERVICE_API_URL";
//# sourceMappingURL=PrepClient.js.map